import React from "react";
import Header from "../components/Header";

import Footer from "../components/Footer";

const ServicePage = () => {
  return (
    <div className="">
      <div className="flex min-h-screen flex-col">
        <Header />
        <div>
          <section className="mb-10 mt-12 pt-1 lg:mb-24 lg:mt-14">
            <div className="pt-16 lg:pt-24">
              <div className="container">
                <div className="font-oswald mx-auto flex max-w-[1052px] flex-col items-center text-center">
                  <h1 className="text-3.5xl md:text-4.5xl mb-6 text-blue-800 lg:mb-8 lg:text-[4rem]">
                    <p className="text-black">NEXT-GENERATION</p>
                    <p>
                      <strong>WATER MANAGEMENT TOOL</strong>
                    </p>
                  </h1>
                  <div className="font-poppins mb-10 md:text-2xl lg:mb-8">
                    <p>
                      MMS is an innovative platform designed to streamline and
                      optimize water meter management. It unlocks the full
                      potential of Nyirendas' platform devices, providing a
                      future-proof solution for efficient water usage
                      monitoring. Available in both mobile and web versions, it
                      ensures maximum accessibility and ease of use.
                    </p>
                  </div>
                  <div className="flex w-full justify-center">
                    <a
                      tabIndex={0}
                      href="/auth"
                      target="_blank"
                      className="ignore-has-link width--large inline-block focus:outline-none"
                    >
                      <div
                        tabIndex={-1}
                        className="content font-oswald active-border--light px--large flex w-full items-center justify-center rounded-md bg-blue-800 px-4 py-2 text-lg uppercase leading-6 text-white transition-all duration-200 hover:bg-blue-800 md:w-auto md:py-4 md:text-xl"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon sprite-telematics mr-2 h-6 w-6"
                        >
                          <path d="M3 3h18v18H3z" />
                          <path d="M9 3v18" />
                          <path d="M15 3v18" />
                        </svg>
                        <div className="text-left font-medium">GET STARTED</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-16 lg:mb-24">
            <div className="relative">
              <img
                src={require("../assets/images/bg-hero-solutions.png")}
                loading="lazy"
                width="1920"
                height="auto"
                alt="background"
                className="-z-1 absolute left-0 top-0 h-full w-full object-contain lg:object-fill"
              />
              <div className="w-full px-1 md:px-24">
                <div className="mx-auto">
                  <img
                    src={require("../assets/images/desktop.png")}
                    loading="lazy"
                    alt=""
                    className="mx-auto max-h-[672px] w-full object-contain"
                    style={{
                      aspectRatio: 3 / 2,
                      filter: "drop-shadow(rgba(0, 0, 0, 0.06) 0px 2px 4px)",
                    }}
                  />
                  {/* <video muted="muted" loop="loop" autoplay="autoplay" playsinline="" controlslist="nofullscreen" class="max-h-[672px] object-contain mx-auto" style={{ aspect- ratio: 3 / 2; filter: drop-shadow(rgba(0, 0, 0, 0.06) 0px 2px 4px);}>
                              <source src="/cdn/products/2024/07/66a09ef10453b4-91267225/main-animation-v28-ftc-handbrake.mp4" type="video/mp4"></video> */}
                </div>
              </div>
            </div>
          </section>

          <section className="mb-16 lg:mb-24">
            <div className="container">
              <div className="font-poppins grid gap-y-6 md:grid-cols-2 md:gap-x-[94px] lg:grid-cols-3 lg:gap-x-6 lg:gap-y-24">
                {/* Enhanced Usability */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-8 w-8 text-blue-800"
                    >
                      <path d="M12 8a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h4z" />
                      <path d="M4 12H2" />
                      <path d="M22 12h-2" />
                      <path d="M12 4V2" />
                      <path d="M12 22v-2" />
                    </svg>
                    {/* React Icon for settings */}
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>ENHANCED USABILITY</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Seamlessly configure water meters with intuitive grouping,
                      reducing the need for external documentation.
                    </p>
                  </div>
                </div>

                {/* Automatic Update */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-8 w-8 text-blue-800">
                    <path d="M17 3a4 4 0 0 1 0 8"/>
                    <path d="M7 3a4 4 0 0 1 0 8"/>
                    <path d="M12 13v8"/>
                    </svg>
                    {/* React Icon for refresh */}
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>AUTOMATIC UPDATES</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Stay up-to-date with the latest features and improvements
                      for water meter management with automatic software
                      updates.
                    </p>
                  </div>
                </div>

                {/* TCT Web Version */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-8 w-8 text-blue-800"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M2 12a10 10 0 0 1 20 0" />
                      <path d="M12 2v20" />
                    </svg>
                    {/* React Icon for web */}
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>WEB VERSION</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Easily manage water meter configurations directly through
                      the web interface, saving changes instantly to the system.
                    </p>
                  </div>
                </div>

                {/* Search Field */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-8 w-8 text-blue-800"
                    >
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                    {/* React Icon for search */}
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>SEARCH FIELD</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Quickly locate specific parameters for water meter
                      settings and configurations to enhance efficiency.
                    </p>
                  </div>
                </div>

                {/* Parameter Dependencies */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-8 w-8 text-blue-800"
                    >
                      <path d="M13 2L6 9V21h12V9l-7-7z" />
                      <path d="M6 15l9-9" />
                    </svg>
                    {/* React Icon for tags */}
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>PARAMETER DEPENDENCIES</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Follow intelligent suggestions to configure dependent
                      parameters for effective water meter management.
                    </p>
                  </div>
                </div>

                {/* Setup Wizard */}
                <div className="flex flex-col items-center text-center">
                  <div className="shadow-2 rounded-2xl bg-white p-2 lg:p-5">
                    <svg
                      className="h-8 w-8 text-blue-800"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                    </svg>
                  </div>
                  <div className="font-oswald mt-4 text-2xl font-semibold uppercase md:mt-6">
                    <p>SETUP WIZARD</p>
                  </div>
                  <div className="mt-4 lg:px-[38px]">
                    <p>
                      Let MMS guide you step-by-step through water meter setup,
                      offering configuration tips and advice along the way.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicePage;
